import React from 'react';
import { Card, Accordion } from 'react-bootstrap';
import { ChevronRight } from '@icons';

const QuestionnaireInstructionComponent = ({ translations }) => {
  const instructionSection = (
    <div>
      <div className='instructionSection'>
        <p>
          Il <b>questionario ESG</b> fornisce informazioni utili a delineare l’esposizione ai
          fattori ESG - ambientale (E), Sociale (S) e di Governo (G) -, sia del progetto per cui si
          richiede il contributo che del soggetto promotore/proponente.
        </p>
        <p>
          Il questionario, quindi, restituisce una panoramica dell’approccio alla sostenibilità del
          promotore/proponente, in particolare della sua capacità di rispettare pratiche ambientali,
          sociali e di governo - al fine di integrare nelle valutazioni inerenti al suo merito
          creditizio quelle relative ai fattori ESG.
        </p>
        <p>
          Al termine della compilazione è tracciato un profilo attraverso il quale sono analizzati e
          misurati in modo sistemico gli aspetti legati alle questioni ambientali, sociali e di
          governance.
        </p>
        <p>
          Ad ogni fattore viene assegnato un punteggio che fornisce una informazione di sintesi sul
          grado di conformità con le direttive internazionali in materia di sostenibilità,
          sull’impatto ambientale generato dall’attività economica svolta, sul rispetto dei valori
          sociali e sugli aspetti legati alla <i>governance</i> societaria, o sul grado di rischio a
          cui un soggetto è sottoposto in relazione a tali fattori.
        </p>
        <p>
          Il questionario contiene domande raggruppate per fattore ESG, consentendo al rispondente
          di concentrarsi su un fattore alla volta.
        </p>
        <p>
          <u style={{ textDecorationColor: '#c2c923' }}>
            Affinché la valutazione vada a buon fine e risulti possibile inviare il questionario, il
            promotore/proponente deve obbligatoriamente rispondere a tutte le domande.
          </u>
        </p>
        Le domande all’interno del questionario sono formulate seguendo tale impostazione:
        <ul>
          <li>
            per le domande che richiamano la struttura, il rispondente deve fornire una risposta
            facendo riferimento al progetto specifico per il quale si richiede l’erogazione del
            finanziamento da parte di ICS;
          </li>
          <li>
            per le domande che menzionano esclusivamente il promotore/proponente, il rispondente
            deve fornire una risposta facendo riferimento alla sua struttura organizzativa e alle
            sue politiche e regolamenti interni.
          </li>
        </ul>
        <p>
          Le domande provviste di esempi o definizioni utili a una migliore comprensione del quesito
          sono dotate di uno specchietto informativo che si apre ogni volta che il mouse viene
          passato sull’icona recante la lettera <i>i</i>&nbsp;&nbsp;(informazioni).
        </p>
        <p>
          Alle domande in cui viene richiesto il possesso di una certificazione o documentazione, se
          si risponde in modo affermativo, bisogna inviare una copia della documentazione a ICS
          tramite email.
        </p>
      </div>

      <div
        className='my-5'
        style={{ borderTop: '2px solid #c2c923', width: '10%', margin: 'auto' }}></div>

      <div className='mt-4 px-3'>
        <p>
          {translations
            .filter((trans) => trans.code === 'ICS110')
            .map((trans) => trans.description)}
        </p>
        <p>
          {translations
            .filter((trans) => trans.code === 'ICS111')
            .map((trans) => trans.description)}
        </p>
        <p>
          {translations
            .filter((trans) => trans.code === 'ICS112')
            .map((trans) => trans.description)}
        </p>
      </div>
    </div>
  );

  return (
    <div>
      <div className='simple-box instruction'>
        <div className='row'>
          <div className='col-lg-12'>
            <Accordion className='fade-in-accordion' id='fade-in-accordion'>
              <Accordion.Collapse style={{ marginTop: '2rem' }} eventKey={1} timeout={1000}>
                <Card.Body>{instructionSection}</Card.Body>
              </Accordion.Collapse>
              <Accordion.Toggle
                as='h5'
                className='accordion-title'
                eventKey={1}
                style={{ margin: '0' }}>
                <div className='row p-2'>
                  <div className='col-10 px-3'>
                    <div
                      className='d-flex align-items-center text-uppercase'
                      style={{ height: '100%' }}>
                      Istruzioni
                    </div>
                  </div>
                  <div className='col-2 align-self-center pl-2 px-0 text-center'>
                    <ChevronRight className='accordion-arrow' />
                  </div>
                </div>
              </Accordion.Toggle>
            </Accordion>
          </div>
        </div>
      </div>

      <h5 className='text-center' style={{ marginTop: '3rem', marginBottom: '3rem' }}>
        Scopri tutte le sezioni del questionario per continuare la tua valutazione.
      </h5>
    </div>
  );
};

export default QuestionnaireInstructionComponent;
